import React, { Component } from "react";
import { Fade as Hamburger } from 'hamburger-react'
import { Nav } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';

class MobileNav extends Component  {
    constructor(props) {
        super(props)
        this.state = {
            open: false,
        }
    }

    componentDidMount() {
        // Check if URL hash contains 'donate-button' and trigger toggle
        
        if (window.location.hash === '#donate-button') {
            this.setState({ open: true });
            // Scroll to top of page if URL hash is empty
            window.scrollTo(0, 0);
        }
    }

    toggle = (toggled) => {
        this.setState({
            open: toggled,
        })
    }

    render() {
        return (
            <div> 
                <Hamburger size={28} label="Show menu" toggled={this.state.open} onToggle={this.toggle}/>
                {this.state.open && 
                    <div className="mobile-hamburgerContainer">
                        <div id="basic-navbar-nav" className="dropDownMenu">
                            <Nav.Link className="linkStyle mobileLinkStyle" target="_blank" href="https://accessos.io/how-it-works/">
                                How accesSOS Works</Nav.Link>
                            <hr/>
                            <Nav.Link className="linkStyle mobileLinkStyle" onClick={() => {
                                        // Trigger a smooth scroll to the 'steps' div - this way of doing it is required to
                                        // work on chrome browsers.
                                        location.href = "#";
                                        location.href = "#steps"; }}>
                                How Text to 911 Works
                            </Nav.Link>
                            <hr/>
                            <Nav.Link className="linkStyle mobileLinkStyle" href="#FAQ">
                                FAQ
                            </Nav.Link>
                            <hr/>
                            <Nav.Link className="linkStyle mobileLinkStyle" target="_blank" href="https://accessos.io/resources_page/">
                                Resources
                            </Nav.Link>
                            <hr/>
                            <Nav.Link id="donate-button" className="linkStyle mobileLinkStyle" target="_blank" href="https://donorbox.org/911textapp-nationwide" onClick={() => {
                                // Google Analytics event tracking
                                if (typeof gtag !== 'undefined') {
                                    gtag('event', 'mobile_donate_button_clicked', {
                                        'button_name': 'donate-button-mobile'
                                    });
                                }
                            }}> 
                                Donate
                            </Nav.Link>
                            <hr/>
                            <div id="download-app" className="subscribeReminder">
                                The accesSOS app connects you to 911, no call needed.&nbsp;
                                <a style={{padding: '0 0.2em 0 0.2em', fontSize: '1em'}} target="_blank" rel="noreferrer" onClick={(e) => {
                                    e.preventDefault();
                                    // Google Analytics event tracking
                                   
                                    if (typeof gtag !== 'undefined') {
                                        gtag('event', 'mobile_download_app_clicked', {
                                            'button_name': 'download-app-mobile'
                                        });
                                    }
                                    // Manually open the link in new tab
                                    window.open('https://qr.accessos.io/appdownload', '_blank');
                                }}> 
                                    <b><u>Download now</u></b> 
                                </a>
                            </div>
                            {/* <div className="subscribeReminder subscribeDropdown">
                                Keep up to date with accesSOS:  
                                <a style={{padding: '0 0.2em 0 0.2em', fontSize: '1em'}} target="_blank" href="https://accessos.io/contact/"> 
                                    <b><u>Sign up here</u></b> 
                                </a>
                                to get notified.
                            </div> */}
                        </div>
                        
                    </div>
                }
            </div>
        )
    }
}

export default MobileNav